// extracted by mini-css-extract-plugin
export default {"share-referral":"ShareReferral_share-referral__aqjZR","share-referral__title":"ShareReferral_share-referral__title__7gq0n","loader":"ShareReferral_loader__OFjwm"};